import { TableCell, TableRow } from '@mui/material';
import MinSingleSelect from '../../MinSingleSelect';
import { IconDelete } from '../../../../icons/Icon'
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

interface AddMogTableRowProps {
    mogList: any;
    setShowAddMog: React.Dispatch<React.SetStateAction<boolean>>;
    handleAddNewMog: (mogcode:string) => void;
}

const AddMogTableRow: React.FC<AddMogTableRowProps> = ({ mogList, setShowAddMog, handleAddNewMog }) => {
    const [mogCode, setMogCode] = useState<string>('');
    const { mogsData } = useSelector((state: any) => state.kitchenIndentProduction);
    const existingMogArray = mogList?.length ? mogList?.map((recipemog: any) => recipemog?.mogcode) : [];
    const mogOptions = mogsData?.length ? mogsData?.filter((mog: any) => !existingMogArray?.includes(mog?.mogcode)) : [];

    useEffect(() => {
        if (mogCode?.length) {
            handleAddNewMog(mogCode);
        }
    }, [mogCode]);

    return (
        <TableRow>
            <TableCell className="text-left">REQ-000{mogList?.length + 1}</TableCell>
            <TableCell className="text-left">
                <MinSingleSelect
                    options={mogOptions?.map((mog: any) => { return { label: mog?.name, value: mog?.mogcode } })}
                    value={mogCode}
                    onChange={(e) => setMogCode(e.target.value as string)}
                    placeholder='Select'
                />
            </TableCell>
            <TableCell className='grey-bg'>-</TableCell>
            <TableCell>0.0</TableCell>
            <TableCell className="text-left">-</TableCell>
            <TableCell>-</TableCell>
            <TableCell><button onClick={() => setShowAddMog(prev => !prev)} className="delete-btn"><IconDelete /></button></TableCell>
        </TableRow>
    )
}

export default AddMogTableRow